
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private loaded = false;

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  load(
    gtmId: string,
    dataLayerName: string = 'dataLayer',
    env?: { auth: string; preview: string; cookiesWin: string } | null,
  ) {
    if (!gtmId || this.loaded) return;
    this.loaded = true;

    const w = window as any;
    w[dataLayerName] = w[dataLayerName] || [];
    w[dataLayerName].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const firstScript = this.doc.getElementsByTagName('script')[0];
    const gtmScript = this.doc.createElement('script');
    const dl = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';

    const envQs = env
      ? `&gtm_auth=${encodeURIComponent(env.auth)}&gtm_preview=${encodeURIComponent(
          env.preview,
        )}&gtm_cookies_win=${encodeURIComponent(env.cookiesWin)}`
      : '';

    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${dl}${envQs}`;
    firstScript?.parentNode?.insertBefore(gtmScript, firstScript);
  }
}
